/* eslint-disable react/button-has-type */

// Components
import RegistrationFormContainer from "containers/molecules/RegistrationFormContainer";

// Constants
import { GET_POPUP_TYPES } from "constants/popupConfig";

// Icons

// Hooks
import useTranslate from "hooks/useTranslate";
import { useTogglePopup } from "hooks/useTogglePopup";

import "./styles.sass";

const RegistrationBlock = () => {
  const t = useTranslate();

  const { openPopup } = useTogglePopup();

  const handleGoToLogin = () => {
    openPopup(GET_POPUP_TYPES.popup.signIn);
  };

  const handleGoToRecovery = () => {
    openPopup(GET_POPUP_TYPES.popup.recovery);
  };

  return (
    <div className="RegistrationBlock">
      <div className="RegistrationBlock__form">
        <RegistrationFormContainer />
      </div>

      <div className="RegistrationBlock__signin">
        {t("registration.account")}{" "}
        <button onClick={handleGoToLogin}>{t("registration.login")}</button>
      </div>

      <div className="RegistrationBlock__signin">
        {t("registration.account.recovery")}{" "}
        <button onClick={handleGoToRecovery}>
          {t("registration.account.recovery.link")}
        </button>
      </div>
    </div>
  );
};

export default RegistrationBlock;
